module.exports = {
  100: "Inter_100Thin",
  300: "Inter_300Light",
  400: "Inter_400Regular",
  500: "Inter_500Medium",
  700: "Inter_700Bold",
};
